import { TIMETYPES } from './marketdata';

const { Y, D, M } = TIMETYPES;

export const INTERVALS = [
  { name: 'century', time: 100 * Y },
  { name: 'decade', time: 10 * Y },
  { name: 'halfDecade', time: 5 * Y },
  { name: 'year', time: Y },
  { name: 'month', time: M },
  { name: 'date', time: D },
  { name: 'hour', time: 1000 * 60 * 60 },
  { name: 'minute', time: 1000 * 60 }
]

export function getWidth(type, printWidth) {
  return type = 'Print' && printWidth > 114 ?
    printWidth : 300;
}


// WEBPACK FOOTER //
// ./src/ui/constants/axis-intervals.js